module.exports = __webpack_public_path__ + "static/media/learn_more_2.f69fd139.png";